module.exports = __webpack_public_path__ + "img/gauge.6dc98873.png";